function DraggableDirective() {
  return {
    restrict: 'A',
    scope: {
      draggable: '='
    },
    link: function (scope, element) {
      element.draggable(scope.draggable || {});

      if (!('enable' in scope.draggable)) scope.draggable.enable = true;

      scope.$watch('draggable.enable', val => {
        if (val === false) {
          element.draggable('disable');
        } else if (val === true) {
          element.draggable('enable');
        }
      });
    }
  };
}

DraggableDirective.$inject = [];

export default DraggableDirective;



// WEBPACK FOOTER //
// ./src/directives/draggable.js